import api, { authHeader } from "@/store/api";

const auth = {
  namespaced: true,
  state: () => ({
    user: {},
    accounts: { pessoa: [], pet: [], tagFuncionario: [] },
    statusAccounts: 0,
  }),
  mutations: {
    setUser: (state, payload) => (state.user = payload),
    setAccounts: (state, payload) => (state.accounts = payload),
    setStatusAccounts: (state, payload) => (state.statusAccounts = payload),
  },
  actions: {
    register(
      { commit },
      { uid, email, celular, password, terms, accept, tipo, session, idioma }
    ) {
      const headers = {
        SESSION: session?.token || session,
      };
      return new Promise((resolve) => {
        api
          .post(
            `api/user`,
            {
              uid,
              email,
              celular,
              password,
              termoPrivacidade: terms,
              aceite: accept,
              tipo,
              idioma,
            },
            { headers }
          )
          .then((result) => {
            commit("setUser", { uid, email });
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
          });
      });
    },
    logout({ commit }) {
      commit("setStatusAccounts", 0);
      commit("setUser", {});
    },
    login({ commit }, { email, password }) {
      return new Promise((resolve) => {
        api
          .post("api/auth", { email, password })
          .then((result) => {
            commit("setUser", {
              id: result.data.content.user.uid,
              email,
              token: result.data.content.jwt,
              tipo: result.data.content.user.tipo,
            });
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
          });
      });
    },
    loginAccount({ commit }, { token, email, type, uid }) {
      commit("setStatusAccounts", 1);
      return new Promise((resolve) => {
        api
          .post(
            "api/auth/account/" + type,
            { email, password: "********", uid },
            {
              headers: authHeader(token),
            }
          )
          .then((result) => {
            commit("setUser", {
              id: result.data.content.user.uid,
              email,
              token: result.data.content.jwt,
              tipo: result.data.content.user.tipo,
            });
            commit("setStatusAccounts", 0);
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
            commit("setStatusAccounts", 0);
          });
      });
    },
    registerLogin({ commit }, { uid, email, password, context, session }) {
      const headers = {
        SESSION: session?.token || session,
      };
      return new Promise((resolve) => {
        const url =
          context === "pessoa"
            ? "api/userPerson"
            : context === "pet"
            ? "api/userPet"
            : context === "tagFuncionario"
            ? "api/userTag"
            : "";
        api
          .post(url + "/register", { email, password, uid }, { headers })
          .then((result) => {
            commit("setUser", {
              id: result.data.content.user.uid,
              email,
              token: result.data.content.jwt,
              tipo: result.data.content.user.tipo,
            });
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
          });
      });
    },
    getAccounts({ commit }, { token }) {
      commit("setStatusAccounts", 1);
      return new Promise((resolve) => {
        api
          .get("api/user/accounts", {
            headers: authHeader(token),
          })
          .then((result) => {
            commit("setAccounts", result.data.content);
            commit("setStatusAccounts", 0);
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
            commit("setStatusAccounts", 0);
          });
      });
    },
    check({ commit, state }) {
      return new Promise((resolve) => {
        api
          .post("api/auth/check", {}, { headers: authHeader(state.user.token) })
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            console.error(err);
            resolve(err.response);
            commit("setUser", {});
          });
      });
    },
  },
};

export default auth;
